/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Response body fields which will be returned while fetching the list of countries. The DTO is in XML or .json format
 * @export
 * @interface Country
 */
export interface Country {
    /**
     * Country code in iso format
     * @type {string}
     * @memberof Country
     */
    isocode?: string;
    /**
     * Name of the country
     * @type {string}
     * @memberof Country
     */
    name?: string;
}

/**
 * Check if a given object implements the Country interface.
 */
export function instanceOfCountry(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CountryFromJSON(json: any): Country {
    return CountryFromJSONTyped(json, false);
}

export function CountryFromJSONTyped(json: any, ignoreDiscriminator: boolean): Country {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isocode': !exists(json, 'isocode') ? undefined : json['isocode'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function CountryToJSON(value?: Country | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isocode': value.isocode,
        'name': value.name,
    };
}

